import I18n from '@/modules/i18n';
import showToast from '@/components/common/Toast';
import useUpdateSlideFrame from '@/hooks/api/useUpdateSlideFrame';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';

export default function useApplyFrame(slide: ISlide) {
  const updateSlide = useSlideShowContext(state => state.updateSlide);
  const { isLoading, mutate } = useUpdateSlideFrame(slide.id);

  const applyFrame = (slideFrameId: number | null, onDone?: () => void) => {
    mutate(slideFrameId, {
      onError: () => showToast(I18n.t('unable_to_update_frame'), { msgType: 'error', position: 'bottom-right' }),
      onSuccess: (data) => {
        updateSlide(slide.id, {
          mascotEnabled: data.mascotEnabled ?? false,
          slideFrame: data.slideFrame ?? undefined,
          slideFrameId: data.slideFrameId ?? undefined,
        });
        onDone?.();
      },
    });
  };

  return { applyFrame, isLoading };
}
